export default "__VITE_ASSET__DjtPFNrK__"